import { TdmzEvent } from '@app/api';
import { BaseEvent } from '../Calendar';
import { EventType } from '../hooks/useGetEventClassNames';

export const tdmzEventToCalendarEvent = (
  event: TdmzEvent,
): BaseEvent | null => {
  return {
    id: event.id,
    start: event.start,
    end: event.end,
    type: EventType.APPOINTMENT,
    title: event.title,
    editable: false,
    attendees: event.participants,
  };
};

export const tdmzEventsToCalendarEvents = (events: TdmzEvent[]) =>
  events.map(tdmzEventToCalendarEvent).filter(Boolean) as BaseEvent[];
